/* The source of truth for hardcoded URL paths */
const aboutRouteBasePath = `/about-the-met`;
const visitRouteBasePath = `/plan-your-visit`;
// TODO: Remove this when we remove this temp launch day fix.
const WATSON_LIBRARY_SCHEDULES_TEMP_PATH =
	'/departments/thomas-j-watson-library/schedules';
export const artCollectorRoute = `research-centers/leonard-a-lauder-research-center/research-resources/modern-art-index-project`;
export const archivalCollectionsRoute = '/research/archival-collections';
export const departmentsRoute = '/departments';
export const departmentLibraryCollectionsRoute = (departmentSlug: string) =>
	`${departmentsRoute}/${departmentSlug}/library-collections`;
export const departmentDigitalCollectionsRoute = (departmentSlug: string) =>
	`${departmentsRoute}/${departmentSlug}/digital-collections`;
export const departmentResearchGuidesRoute = (departmentSlug: string) =>
	`${departmentsRoute}/${departmentSlug}/research-guides`;
export const departmentLibraryCollectionRoute = (
	departmentSlug: string,
	libraryCollectionSlug: string,
) =>
	`${departmentLibraryCollectionsRoute(departmentSlug)}/${libraryCollectionSlug}`;
export const departmentProfessionalResourcesRoute = (departmentSlug: string) =>
	`${departmentsRoute}/${departmentSlug}/professional-resources`;
export const departmentProfessionalResourceRoute = (
	departmentSlug: string,
	resourceSlug: string,
) => `${departmentProfessionalResourcesRoute(departmentSlug)}/${resourceSlug}`;

export * from './route-for-document';

// The type safety here was a feature not a bug.
// All routes in this object have related Sanity Documents.
export const routesWithSanityDocuments: Record<
	string,
	(slug?: string) => string
> = {
	aboutLandingPage: () => aboutRouteBasePath,
	annualReportPage: () => `/support/annual-reports`,
	archivalResource: () => archivalCollectionsRoute,
	archivesIndexPage: () => archivalCollectionsRoute,
	artCollector: (slug?: string) => `/${artCollectorRoute}/${slug}`,
	article: (slug?: string) => `/perspectives/${slug}`,
	atopiaViewerPage: (slug?: string) => `/atopia/${slug}`,
	audioFile: (slug?: string) => `/audio-guide/audio/${slug}`,
	audioGuideLandingPage: () => `/audio-guide`,
	audioPlaylist: (slug?: string) => `/audio-guide/playlists/${slug}`,
	bluffAlmanachVolume1: () =>
		`/research-centers/bluff-collaborative-for-research-on-dada-and-surrealism/volume-1-man-ray`,
	careersLandingPage: () => `/opportunities/careers`,
	closeLook: (slug?: string) => `/perspectives/close-look/${slug}`,
	collectionLandingPage: () => `/art/collection`,
	contactUs: () => `${aboutRouteBasePath}/contact-us`,
	corporateSupport: () => `/support/corporate-support`,
	crdCollection: (slug?: string) => `/collections/${slug}`,
	department: (slug?: string) => `${departmentsRoute}/${slug}`,
	digitizedPrimarySource: (slug?: string) =>
		`/research/resources/digitized-primary-sources/${slug}`,
	diningLandingPage: () => `${visitRouteBasePath}/dining`,
	diningLocation: () => `${visitRouteBasePath}/dining`,
	essay: (slug?: string) => `/essays/${slug}`,
	eventsLandingPage: () => `/events`,
	exhibition: (slug?: string) => `/exhibitions/${slug}`,
	exhibitionLandingPage: () => `/exhibitions`,
	fellowshipDoc: (slug?: string) => `/opportunities/fellowships/${slug}`,
	fellowshipFAQPage: () => `/opportunities/fellowships/faq`,
	fellowshipsLandingPage: () => `/opportunities/fellowships`,
	fellowsIndex: () => `/opportunities/fellowships/current-and-former-fellows`,
	friendsGroup: (slug?: string) => `/support/friends-groups/${slug}`,
	friendsGroupsLandingPage: () => `/support/friends-groups`,
	galleryViewer: (slug?: string) => `/gallery-viewer/${slug}`,
	givingResource: (slug?: string) =>
		`/support/planned-giving/resources/${slug}`,
	groupVisitLandingPage: () => `${visitRouteBasePath}/group-visits`,
	groupVisitType: (slug?: string) =>
		`${visitRouteBasePath}/group-visits/${slug}`,
	historyOfTheMet: () => `${aboutRouteBasePath}/history`,
	homepage: () => `/`,
	hostAnEventPage: () => `/support/host-an-event`,
	hubPage: (slug?: string) => `/hubs/${slug}`,
	internship: (slug?: string) => `/opportunities/internships/${slug}`,
	internshipFAQPage: () => `/opportunities/internships/faq`,
	internshipPlacementAreas: () =>
		`/opportunities/internships/departmental-placement-areas`,
	internshipsLandingPage: () => `/opportunities/internships`,
	internsIndex: () => `/opportunities/internships/current-and-former-interns`,
	journal: (slug?: string) => `/met-publications/${slug}`,
	leadership: () => `${aboutRouteBasePath}/leadership`,
	locationPage: (slug?: string) => `${visitRouteBasePath}/${slug}`,
	membershipFAQPage: () => `/support/membership/membership-faqs`,
	opportunitiesLandingPage: () => `/opportunities`,
	periodRoomInteractive: (slug?: string) => `/kiosk/period-room/${slug}`,
	perspectivesLandingPage: () => `/perspectives`,
	plannedGivingLandingPage: () => `/support/planned-giving`,
	planYourVisit: () => visitRouteBasePath,
	policiesLandingPage: () => `${aboutRouteBasePath}/policies`,
	policy: (slug?: string) => `/policies/${slug}`,
	pressHomepage: () => '/press',
	pressRelease: (slug?: string) => `/press-releases/${slug}`,
	professionalResource: (slug?: string) =>
		`${departmentsRoute}/professional-resources/${slug}`,
	publication: (slug?: string) => `/met-publications/${slug}`,
	publicationLandingPage: () => `/met-publications`,
	researchAtTheMetLandingPage: () => `/research`,
	researchCenter: (slug?: string) => `/research-centers/${slug}`,
	researchProject: (slug?: string) => `/research/projects/${slug}`,
	series: (slug?: string) => `/perspectives/series/${slug}`,
	studioAt81stStreet: () => `${visitRouteBasePath}/81st-street-studio`,
	studyCollectionsPage: () => `/research/study-collections`,
	supportersList: (slug?: string) => `/support/${slug}`,
	supportLandingPage: () => '/support',
	toahLandingPage: () => `/essays/timeline-of-art-history`,
	vacheronConstantinArtisanResidency: () =>
		`/vacheron-constantin-artisan-residency`,
	visitGuide: (slug?: string) => `/visit-guides/${slug}`,
	visualDatabase: (slug?: string) =>
		`/research/resources/visual-databases/${slug}`,
	volunteer: (slug?: string) => `/support/volunteer/${slug}`,
	volunteerLandingPage: () => `/support/volunteer`,
	watsonLibrarySchedules: () => WATSON_LIBRARY_SCHEDULES_TEMP_PATH,
	wayOfGiving: (slug?: string) => `/support/planned-giving/${slug}`,
	welcomePage: () => `/welcome`,
};

export const routes = {
	...Object.keys(routesWithSanityDocuments),
	advancedCollectionSearch: (
		params?: ConstructorParameters<typeof URLSearchParams>[0],
	) => {
		const path = `/art/collection/search`;
		return params ? `${path}?${new URLSearchParams(params)}` : path;
	},
	object: (id: string | number) => `/art/collection/search/${id}`,
};
